import { useSelector } from 'react-redux';
import { getShowHiddenElements } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { useBreakpointContext } from 'EmailEditorUI/components/mo/BreakpointContext';
// @ts-expect-error no declarations found for module
import { getIsSectionBoxedHelper } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import { isHiddenForBreakpoint } from 'EmailEditorUI/utils/breakpointUtils';
function useVisibleBoxBoundaries(layoutSettings, sections) {
  var _layoutSettings$get, _layoutSettings$get2;
  const {
    breakpointName
  } = useBreakpointContext();
  const showHiddenElements = useSelector(getShowHiddenElements);
  const boxed = layoutSettings.get('boxed');
  const boxFirstElementIndex = (_layoutSettings$get = layoutSettings.get('boxFirstElementIndex')) !== null && _layoutSettings$get !== void 0 ? _layoutSettings$get : -1;
  const boxLastElementIndex = (_layoutSettings$get2 = layoutSettings.get('boxLastElementIndex')) !== null && _layoutSettings$get2 !== void 0 ? _layoutSettings$get2 : -1;
  if (!boxed) {
    return {
      top: -1,
      bottom: -1
    };
  }
  if (showHiddenElements) {
    return {
      top: boxFirstElementIndex,
      bottom: boxLastElementIndex
    };
  }
  const whereIsBoxedAndVisible = (section, index) => {
    return getIsSectionBoxedHelper(layoutSettings, index) && !isHiddenForBreakpoint(breakpointName, section.get('style'));
  };
  const top = sections.findIndex(whereIsBoxedAndVisible);
  const bottom = sections.findLastIndex(whereIsBoxedAndVisible);
  return {
    top: top === -1 ? boxFirstElementIndex : top,
    bottom: bottom === -1 ? boxLastElementIndex : bottom
  };
}
export default useVisibleBoxBoundaries;